<div style="position: relative;">
  <div #mailTo class="filter-bttn tags-sec" (click)="toInput.focus()">
    <div class="tag" [class.highlighted]="tag?.highlighted" *ngFor="let tag of emailTags.tags" [title]="tag.email">
      <div *ngIf="tag?.firstName || tag?.lastName">{{tag?.firstName}} {{tag?.lastName}}</div>
      <div *ngIf="!tag?.firstName && !tag?.lastName">{{tag.email}}</div>
      <div class="hover-bttn" (click)="emailTags.deleteTag(tag)">
        <ion-icon name="fa-x-mark"></ion-icon>
      </div>
    </div>
    <input #toInput type="email" placeholder="E-Mail-Adressen..." 
    (focus)="emailTags.focus()"
    (blur)="blur()"
    [(ngModel)]="emailTags.searchText"
    (keydown)="emailTags.keyenterPressed($event)"
    (keydown.escape)="toInput.blur()">

  </div>

  <div [ngStyle]="{'top.px': mailTo.getClientRects().item(0)?.height + 20}" ArrowKeyUseable [arrowKeysOptions]="emailTags.arrowKeysOptions"  >
    <div class="email-select-box" *ngIf="emailTags.focused">
      <div class="no-content" *ngIf="emailTags.emailAdresses.length == 0" style="margin: 15px 0; font-size: 14px;">
        Keine Email-Adressen
      </div>
      <ion-item *ngFor="let item of emailTags.emailAdresses; let i = index" (click)="itemClicked(item)" (mouseenter)="emailTags.arrowKeysOptions.mouseOverItem.next(i)" (mousemove)="emailTags.arrowKeysOptions.mouseMove.next(true)">
        <ion-label>{{item?.firstName}} {{item?.lastName}} ({{item.email}})</ion-label>
      </ion-item>
    </div>
  </div>

</div>